var map = {
	"./back-in-stock-popup.vue": 5778,
	"./product-accordion.vue": 8047,
	"./product-add-actions.vue": 2245,
	"./product-gallery.vue": 6543,
	"./product-information.vue": 4533,
	"./product-recommendations.vue": 3204,
	"./product-sale-badge.vue": 414,
	"./product-selling-plans.vue": 7717,
	"./product-setup.vue": 2092,
	"./product-variants.vue": 8005,
	"./sticky-action-bar.vue": 8695,
	"./variant-collection-buttons.vue": 7852,
	"./variant-collection-slideout-trigger.vue": 4129,
	"./variant-collection-slideout.vue": 7082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6304;